module.exports = __webpack_public_path__ + "static/assets/067e4399dc37cf3a5acc40edd4d807c4.png";